import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Breadcrumbs } from '@mui/material';
import withNotify from '../../common/withNotify';
import { notifySet } from '../../Services/Actions/CommonActions';
import StartUpForm from './StartUpForm';
import { addStartUp } from '../../Services/Utils/StartupApis';

function AddStartUp() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [processing, setProcessing] = useState(false);

  const onButtonClick = (formData) => {
    setProcessing(true);
    const data = {
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      hasLoggedIn: true,
      roleView: {
        id: 2,
      },
      registeredName: formData.registeredName,
      founderName: formData.founderName,
      pocName: formData.pocName,
      pocEmail: formData.pocEmail,
      pocMobile: formData.pocMobile,
      planView: {
        id: formData.plan.id
      }
    };
    addStartUp(data).then((res) => {
      setProcessing(false);
      if (res.hasError === false) {
        navigate('/startups');
        dispatch(notifySet({ type: 'success', message: res.message }));
      } else if (res.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  return (
    <div className="container-fluid ">
      <div className="breadcrumb-menu-con">
        <Breadcrumbs
          separator=">"
          aria-label="breadcrumb"
        >
          <Link to="/startups">Startup</Link>
          <Link to="#">Add Startup</Link>
        </Breadcrumbs>
      </div>
      <div>
        <div className="row">
          <div className="col-sm-12">
            <StartUpForm
              onButtonClick={onButtonClick}
              startupText="Add Startup"
              processing={processing}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default withNotify(AddStartUp);
